export default {"src":"/_next/static/media/purple-arrow-down-right.82e073a6.svg","height":48,"width":49,"blurWidth":0,"blurHeight":0};